import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/topics/${resource.id}/edit`} />,
    <MenuItem primaryText='Copy' key='copy' value={`/write-now/topics/${resource.id}/copy`} />
  ]
}

export default buildMenuItems
